import React from "react";

export default (props) => {

  return (
    <React.Fragment>

      <h1 className="page-title">Contacts</h1>
      <p>If you have any questions relating to the MyScan service or would like to check if you can use Broxbourne MyScan for your claim, please <a href="https://www.broxbourne.gov.uk/contact-us/complain-borough-broxbourne-council">contact Broxbourne Borough Council</a>.</p>

    </React.Fragment>
  );
}
